import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

// TODO add types
export const props = withCompInfo<any, any>()(
  ['compData', 'compProps', 'translate'],
  ({ compData, compProps, translate }) => {
    return {
      ...compData,
      ...compProps,
      translations: {
        playControlAriaLabel: translate('ariaLabels', 'PlayControl_AriaLabel'),
        pauseControlAriaLabel: translate(
          'ariaLabels',
          'PauseControl_AriaLabel',
        ),
      },
    };
  },
);

export const stateRefs = withStateRefsValues(['reducedMotion', 'experiments']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
